export default {
  hint: '您暂时无法访问该页面',
  reason: '可能原因如下',
  noPage: '该页面不存在',
  noPermission: '您暂无权限访问该页面',
  relation: '如有问题，请联系系统管理员',
};
